<template>
  <div>
    <div class="section-right-content-box">
      <div class="box-shadow top-box">
        <div class="global-title">{{ $route.meta.title }}
          <el-popover
            placement="right"
            width="480"
            trigger="hover"
          >
            <div>1、统计已付款订单</div>
            <div>2、按月维度进行分析</div>
            <div>3、留存率：复购时间段内的复购人数/购买时间段内的购买人数</div>
            <div v-if="$route.meta.title == '新客留存率分析'">4、新客：首次购买时间在选择的购买时间范围内</div>
            <div v-else>4、老客：首次购买时间在选择的付款时间范围前</div>
            <div>5、首购年份不可与复购年份一致</div>
            <i class="el-icon-question" slot="reference" style="color: #aaaaaa;"></i>
          </el-popover>
        </div>
      </div>
      <div class="keep_analysis">
        <!-- 查询条件 -->
        <el-form ref="form" :model="form" label-width="254px">
          <el-form-item :label="$route.meta.title == '新客留存率分析' ? '首次付款时间（年）：' : '付款时间（年）：'" required>
            <el-date-picker
              style="width: 205px"
              v-model="form.firstBuyYear"
              type="year"
              :picker-options="firstBuyYearPicker"
              :clearable="false"
              placeholder="请选择">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$route.meta.title == '新客留存率分析' ? '留存率分析周期 - 复购时间（年）：' : ' 留存率分析周期 - 复购时间（年）：'" required>
            <el-date-picker
              style="width: 205px"
              v-model="form.reBuyYear"
              type="year"
              :picker-options="reBuyYearPicker"
              :clearable="false"
              placeholder="请选择">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-button class="status_btn status_btn1" icon="el-icon-search" type="primary" @click="queryData">查询</el-button>
            <el-button class="status_btn status_btn2" @click="resetData">重置</el-button>
            <el-button class="exportData" @click="exportData">导出数据</el-button>
          </el-form-item>
        </el-form>
        <el-table
          :data="tableData"
          border
          :header-cell-style="{ background: '#fafafa', fontWeight: 700 }"
          style="width: 100%; margin-top: 24px;"
          :default-sort = "{prop: 'date', order: 'ascending'}"
          v-loading="loading"
          show-summary
          :summary-method="getSummaries"
        >
          <el-table-column label="首次付款日期" align="center">
            <el-table-column prop="date" label="首次付款日期" align="center" sortable width="130"></el-table-column>
            <el-table-column prop="payNum" label="付款人数" align="center" sortable width="120"></el-table-column>
          </el-table-column>
          <el-table-column :label="`${tableYear}年${item}月复购`" align="center" v-for="item in 12" :key="item">
            <el-table-column :prop="`reBuyNum${item}`" label="复购人数" align="center" sortable width="120"></el-table-column>
            <el-table-column :prop="`retention${item}Sort`" label="留存率" align="center" sortable width="120">
              <template slot-scope="scope">
                {{ scope.row[`retention${item}`] }}
              </template>
            </el-table-column>
          </el-table-column>
          <template slot="empty">
            <div class="empty">
              <img src="@/assets/images/default/暂无任何数据.png" />
              <div>暂无任何数据</div>
            </div>
          </template>
        </el-table>
      </div>
    </div>

    <!-- 生成报表 -->
    <generate
      v-if="control"
      :control="control"
      @transData="(val) => (control = val)"
      @transData1="getphone"
    />
  </div>
</template>

<script>
import generate from "@/components/generate_report.vue";
import { exportDataOne, getTableData } from "@/api/analysis/keep_analysis";

export default {
  components: {
    generate,
  },

  data() {
    return {
      loading: false,
      control: false,
      tableYear: new Date().getFullYear(), // 当前年份
      form: {
        // 表单查询条件
        firstBuyYear: (new Date().getFullYear() - 1).toString(),
        reBuyYear: new Date().getFullYear().toString(),
      },
      tableData: [], // 表格数据
      exportParams: {}, // 导出参数
      firstBuyYearPicker: {
        disabledDate: (time) => {
          return typeof this.form.reBuyYear == "string" ? this.form.reBuyYear == time.getFullYear() : this.form.reBuyYear.getFullYear() == time.getFullYear()
        },
      },
      reBuyYearPicker: {
        disabledDate: (time) => {
          return typeof this.form.firstBuyYear == "string" ? this.form.firstBuyYear == time.getFullYear() : this.form.firstBuyYear.getFullYear() == time.getFullYear()
        },
      },
    };
  },
  
  created() {
    // 埋点
    this.buriedPoint(1, this.$route.meta.title, "数据分析", "客户分析");
    this.queryData()
  },

  methods: {
    // 自定义合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          for(let i = 0; i < 13; i++) {
            if (column.property == `retention${i}Sort`) {
              if (sums[1] == 0) {
                sums[index] = "0%"
              } else {
                sums[index] = ((sums[index - 1] * 100) / (sums[1])).toFixed(2) + "%";
              }
            }
          }
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    },

    // 查询
    queryData() {
      const params = {
        firstBuyYear: Number(typeof this.form.firstBuyYear == "string" ? this.form.firstBuyYear : this.form.firstBuyYear.getFullYear()),
        reBuyYear: Number(typeof this.form.reBuyYear == "string" ? this.form.reBuyYear : this.form.reBuyYear.getFullYear()),
      }
      this.tableYear = params.reBuyYear
      this.exportParams = {
        ...params,
        customerType: this.$route.meta.title == '新客留存率分析' ? 1 : 2,
      }
      this.loading = true
      getTableData(this.exportParams).then((res) => {
        this.loading = false
        if (res.code != 1) {
          return this.$message.error(res.message || res.data.message)
        }
        if (res.data && res.data.length > 1) {
          res.data.pop()
        }
        this.tableData = res.data || []
        this.tableData.map((item) => {
          for (let i = 1; i < 13; i++) {
            item[`retention${i}Sort`] = Number(item[`retention${i}`].split('%')[0])
          }
        })
      })
    },

    // 重置
    resetData() {
      this.form = {
        firstBuyYear: (new Date().getFullYear() - 1).toString(),
        reBuyYear: new Date().getFullYear().toString(),
      }
      this.queryData()
    },

    exportData() {
      this.control = true;
    },

    getphone(val) {
      const params = {
        ...this.exportParams,
        exportRemark: val,
      };
      exportDataOne(params).then((res) => {
        if (res.code == 1) {
          this.control = true;
        } else {
          this.$message.error(res.message || res.data.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.section-right-content-box {
  min-width: 1046px;
  margin-top: 10px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  margin: 10px 20px 20px 20px;

  .keep_analysis {
    padding: 28px;

    .status_btn {
      width: 98px;
      background-color: #fff;
      font-size: 14px;
      margin-left: 20px;
    }

    .status_btn1 {
      color: #fe4d45;
      border-color: #fe4d45;
      margin-left: 0;
    }

    .status_btn1:hover {
      color: #ffffff;
      background-color: #fe4d45;
    }

    .status_btn2 {
      margin-left: 8px;
      color: #333;
      border-color: #d9d9d9;
    }

    .status_btn2:hover {
      color: #fe4d45;
      border-color: #fe4d45;
      background-color: #ffe5e5;
    }

    .exportData {
      float: right;
    }

    .empty {
      padding: 40px 0;
      text-align: center;
      line-height: 30px;
    }

    .toolTipSet {
      width: 600px !important;
    }

    /deep/.el-input__inner {
      padding: 0 30px !important;
    }

    /deep/.el-table .el-table__header-wrapper {
      height: 94px;
    } 

    /deep/.el-table__empty-block {
      width: 100% !important;
      position: sticky;
      left: 0;
    }

    /deep/.el-table {
      overflow-x: auto;
    }
    /deep/.el-table__header-wrapper,
    .el-table__body-wrapper {
      overflow: visible;
    }
    /deep/.el-table__footer-wrapper {
      overflow: visible;
    }
    /deep/.el-table::after {
      position: relative;
    }
    /deep/.el-table--scrollable-x .el-table__body-wrapper {
      overflow: visible;
    }
  }
}
</style>
